import { useQueryClient } from "@tanstack/react-query";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import TemplateNewForm from "./TemplateNewForm";

interface RosTemplateDrawerProps {
  disclosureHost: DisclosureHost;
}

const RosTemplateDrawer = ({ disclosureHost }: RosTemplateDrawerProps) => {
  const queryClient = useQueryClient();

  const handleRefetchTemplate = () => {
    queryClient.invalidateQueries({ queryKey: ["form-builder-list"] });
  };

  return (
    <SideSheetDrawer
      w="45vw"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      title="Add New ROS Template"
    >
      <TemplateNewForm
        enableOnlyAddApi
        preFillSchema={disclosureHost.data}
        onClose={() => {
          disclosureHost.close();
          handleRefetchTemplate();
        }}
      />
    </SideSheetDrawer>
  );
};

export default RosTemplateDrawer;

interface PeAddTemplateDrawerProps {
  disclosureHost: DisclosureHost;
  title?: string;
}

export const PeAddTemplateDrawer = ({
  disclosureHost,
  title,
}: PeAddTemplateDrawerProps) => {
  const queryClient = useQueryClient();

  const handleRefetchTemplate = () => {
    queryClient.invalidateQueries({ queryKey: ["form-builder-list"] });
  };

  return (
    <SideSheetDrawer
      w="45vw"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      title={title ?? "Add New PE Template"}
    >
      <TemplateNewForm
        enableOnlyAddApi
        preFillSchema={disclosureHost.data}
        onClose={() => {
          disclosureHost.close();
          handleRefetchTemplate();
        }}
      />
    </SideSheetDrawer>
  );
};
